import Rails from '@rails/ujs'
import * as ActiveStorage from '@rails/activestorage'
import 'channels'

import { listenToSelectTagDropdownClick } from './infographics'
import { initFullPage } from './fullPage'
import { loadImages } from './projectItemImages'
import { showSideMenu } from './sideMenu'
import { initQuote } from './quoteRequest'

Rails.start()
ActiveStorage.start()

let page

document.addEventListener('DOMContentLoaded', () => {
  page = document.body.dataset.page

  if ([
    'index',
    'infographics',
    'contact',
    'show_project',
    '_3d_animations',
    'virtual_tours',
    'virtual_reality'
  ].includes(page))
    loadImages()

  showSideMenu()

  if (page !== 'quote')
    initFullPage(page)

  switch (page) {
    case 'infographics':
      listenToSelectTagDropdownClick()
      break
    case 'quote':
      initQuote()
      break
  }
})
